export const credentials = {
  mode: 'subtle-gated',
  label: 'Credentials',
  prompt: 'Initials',
  expected: 'GC',
  acceptedInitials: ['GC', 'GWC'],
  resumeFileName: 'Greg-Cothran-Resume.pdf',
  note: 'A traditional resume is available for recruiters and deeper evaluation.',
  pageMeta: { robots: 'noindex,nofollow', canonical: 'https://gregcothran.com/credentials' }
};
